import { MenuItem, Select } from "@mui/material";
import { usePath } from "../libs/path/PathProvider";

export default function TaxFilter() {
    const items : any[] = []
    const {query,setQuery} = usePath()
    const onYear = (year:number) => setQuery({year})
    const currentYear = parseInt(query.year as string) || new Date().getFullYear()
    let year = new Date().getFullYear()
    for(let i=0; i<10; i++) {
        items.push(<MenuItem value={year-i} key={year-i}>{year-i}</MenuItem>)
    }
    return <Select className="select" value={currentYear} onChange={(e:any) => onYear(parseInt(e.target.value))}>{items}</Select>
}